module.exports = __webpack_public_path__ + "img/user_cancel2.3ef783b3.png";